const loaded = {
  script: null,
  style: false,
};

const publicAsset = (path) => `${process.env.PUBLIC_URL || ""}/sweetalert-assets/${path}`;

const loadStyle = () => {
  if (loaded.style) return;

  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = publicAsset("sweetalert2.min.css");
  document.head.appendChild(link);
  loaded.style = true;
};

const loadScript = () => {
  if (window.Swal) return Promise.resolve(window.Swal);
  if (loaded.script) return loaded.script;

  loaded.script = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = publicAsset("sweetalert2.all.min.js");
    script.onload = () => resolve(window.Swal);
    script.onerror = reject;
    document.body.appendChild(script);
  });

  return loaded.script;
};

const swal = async () => {
  loadStyle();
  return loadScript();
};

export const notify = async (message, icon = "success") => {
  const Swal = await swal();
  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3200,
    timerProgressBar: true,
  });

  return Toast.fire({ icon, title: message });
};

export const confirmAction = async ({
  title = "Confirmar acção",
  text = "Deseja continuar?",
  confirmButtonText = "Sim",
  cancelButtonText = "Cancelar",
  icon = "question",
} = {}) => {
  const Swal = await swal();
  return Swal.fire({
    title,
    text,
    icon,
    showCancelButton: true,
    confirmButtonText,
    cancelButtonText,
    reverseButtons: true,
    confirmButtonColor: "#0874d1",
    cancelButtonColor: "#64748b",
  });
};

const ToastAlert = {
  fire: async (optionsOrTitle, text, icon) => {
    if (typeof optionsOrTitle === "object" && optionsOrTitle !== null) {
      if (optionsOrTitle.showCancelButton) {
        return confirmAction(optionsOrTitle);
      }
      return notify(optionsOrTitle.title || optionsOrTitle.text || "", optionsOrTitle.icon || "success");
    }

    return notify([optionsOrTitle, text].filter(Boolean).join("\n"), icon || "success");
  },
};

export default ToastAlert;
